export default "__VITE_ASSET__iQJkKKRi__"